import React from "react";
import * as PropTypes from "prop-types";
import WorxTextField from "../../Forms/Inputs/WorxTextField";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@mui/styles";
import WorxAutocompleteFormik from "../../Forms/Inputs/WorxAutocompleteFormik";
import { AutoCompleteFilter } from "../../../Constants/Jurisdiction";
import WorxMediaUpload from "../../../Container/Forms/Inputs/WorxMediaUpload";

const buttonUseStyles = makeStyles({
  root: {
    marginLeft: "1em",
  },
});

const useStyles = makeStyles({
  worxSpaceAround: {
    margin: "1em",
  },
});

const OrderItemFormDisplay = (props) => {
  const { formik, jurisdictions, properties } = props;

  const buttonClasses = buttonUseStyles();
  const classes = useStyles();

  return (
    <div className={classes.worxSpaceAround}>
      <WorxTextField fieldKey={"name"} formik={formik} />
      <WorxAutocompleteFormik
        fieldKey={"jurisdiction"}
        options={jurisdictions}
        formik={formik}
      />
      <WorxAutocompleteFormik
        fieldKey={"property"}
        options={properties}
        formik={formik}
      />
      <WorxTextField
        fieldKey={"unit_price"}
        type={"number"}
        trim={2}
        formik={formik}
      />
      <WorxTextField fieldKey={"quantity"} type={"number"} formik={formik} />
      <WorxMediaUpload
        jurisdiction={formik.values?.jurisdiction?.[0]?.id}
        property={formik.values?.property?.[0]?.id}
        type={"document"}
        entityType={"media"}
        fieldKey={"client_documents"}
        formik={formik}
      />
      <Button
        variant={"contained"}
        color="primary"
        margin="normal"
        onClick={() => {
          formik.handleSubmit();
        }}
        classes={{ root: buttonClasses.root }}
      >
        Submit
      </Button>
    </div>
  );
};

OrderItemFormDisplay.propTypes = {
  jurisdictions: AutoCompleteFilter,
  properties: AutoCompleteFilter,
  formik: PropTypes.object.isRequired,
};

export default OrderItemFormDisplay;
